var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"wlReCaptcha",attrs:{"sitekey":_vm.CaptchaClientSiteKey,"size":_vm.sizeValue},on:{"expired":function($event){return _vm.$emit('recaptcha-exipred')},"verify":_vm.onCaptchaVerified}})}
var staticRenderFns = []

export { render, staticRenderFns }